import React, { Component } from 'react';
import PropTypes from "prop-types";

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';

import { StandardPage } from "../../Common/pages/StandardPage";
import { RightColumn } from "../../Common/pages/RightColumn";

export class HorseRacingProfilePage extends Component {
  static propTypes = {
    ProfilePageContainer: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      ProfilePageContainer,
    } = this.props;

    return (
      <div className="horse-profile-page">
        <StandardPage sport="racing" title="Profile page">
          <div className="main-layout-left-column">
            {ProfilePageContainer}
          </div>

          <RightColumn location={location}
                       sport="racing"
                       content={
                         ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu",  "ocWidget"]} />
        </StandardPage>
      </div>
    );
  }
}

export default standardAsyncConnect([
  userServiceLayoutConnect()
])(HorseRacingProfilePage)



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingProfilePage.js